
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.578 11.346c0-.552-.221-.974-.664-1.266C1.477 9.788.839 9.642 0 9.642V7.367c.846 0 1.487-.14 1.924-.419.436-.279.654-.679.654-1.199V2.646c0-.97.326-1.653.977-2.046C4.207.2 5.352 0 6.99 0v2.142c-.665.019-1.125.14-1.38.361-.248.222-.373.55-.373.98V6.33c-.04 1.193-.825 1.897-2.356 2.113v.114c1.57.222 2.356.895 2.356 2.018v2.932c0 .431.125.758.373.98.249.222.708.343 1.38.362V17c-1.638 0-2.783-.2-3.435-.6-.65-.393-.977-1.078-.977-2.056v-2.998zm15.844 2.998c0 .711-.138 1.247-.413 1.609-.276.362-.732.625-1.37.79-.631.171-1.508.257-2.629.257v-2.151c.665-.013 1.121-.127 1.37-.343.255-.216.383-.549.383-1v-2.95c0-.546.198-.987.594-1.323.396-.343.98-.568 1.752-.676v-.114c-1.524-.216-2.306-.92-2.346-2.113V3.484c0-.444-.125-.774-.373-.99-.248-.216-.709-.333-1.38-.352V0c1.121 0 2.001.086 2.639.257.638.165 1.091.432 1.36.8.275.361.413.891.413 1.59v3.121c0 .533.204.933.614 1.2.416.266 1.071.4 1.964.4v2.274c-.84 0-1.48.13-1.924.39-.436.26-.654.698-.654 1.314v2.998z"}})])
          )
        }
      }
    